import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ICardApiResponse } from 'v2/interfaces/customer';
import { customerFactory } from 'v2/services/customer';

function useCardsListSubscriptions(options?: Omit<UseQueryOptions<ICardApiResponse[]>, 'queryKey' | 'queryFn'>) {
  return useQuery({
    queryKey: ['paymentMethods', 'subscriptions'],
    queryFn: () => customerFactory.getCardsListSubscriptionsRequest().toPromise(),
    ...options
  });
}

export { useCardsListSubscriptions };
